module.exports = __webpack_public_path__ + "static/media/smile2.40dd6fbc.svg";